/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Reminder_Days_ErrorInputs */

const en_us2_profile_editors_reminder_days_error = /** @type {(inputs: Profile_Editors_Reminder_Days_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick at least one day.`)
};

const pt_br2_profile_editors_reminder_days_error = /** @type {(inputs: Profile_Editors_Reminder_Days_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha pelo menos um dia.`)
};

const es_419_profile_editors_reminder_days_error = /** @type {(inputs: Profile_Editors_Reminder_Days_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige al menos un día.`)
};

const pt_pt2_profile_editors_reminder_days_error = /** @type {(inputs: Profile_Editors_Reminder_Days_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolhe pelo menos um dia.`)
};

const fr_fr2_profile_editors_reminder_days_error = /** @type {(inputs: Profile_Editors_Reminder_Days_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisis au moins un jour.`)
};

const de_de2_profile_editors_reminder_days_error = /** @type {(inputs: Profile_Editors_Reminder_Days_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähl mindestens einen Tag.`)
};

const it_it2_profile_editors_reminder_days_error = /** @type {(inputs: Profile_Editors_Reminder_Days_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli almeno un giorno.`)
};

/**
* | output |
* | --- |
* | "Pick at least one day." |
*
* @param {Profile_Editors_Reminder_Days_ErrorInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_reminder_days_error = /** @type {((inputs?: Profile_Editors_Reminder_Days_ErrorInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Reminder_Days_ErrorInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_reminder_days_error(inputs)
	if (locale === "es-419") return es_419_profile_editors_reminder_days_error(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_reminder_days_error(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_reminder_days_error(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_reminder_days_error(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_reminder_days_error(inputs)
	return en_us2_profile_editors_reminder_days_error(inputs)
});
export { profile_editors_reminder_days_error as "profile-editors.reminder_days_error" }